import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Form,
  Input,
  Modal,
  Radio,
} from "antd";
import { withTranslation } from 'react-i18next';

import * as DateUtils from '@utils/date';

class UpdateForm extends React.Component {
  static propTypes = {
    tenancy: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    confirmLoading: PropTypes.bool,
  }

  static defaultProps = {
    visible: false,
    confirmLoading: false,
  }

  constructor(props) {
    super(props);
  }

  render() {
    const { tenancy } = this.props;
    if (!tenancy) {
      return null;
    }

    const { form } = this.props;
    const formItemLayout = {
      labelCol: { span: 12 },
      wrapperCol: { span: 12 }
    };

    return (
      <Modal
        visible={this.props.visible}
        title={ this.props.t("Tenancies.actions.UpdateTenancy") }
        okText={ this.props.t("actions.Submit") }
        onCancel={this.props.onCancel}
        onOk={this.props.onOk}
        confirmLoading={this.props.confirmLoading}
      >
        {this.props.children}
        <Form form={this.props.form} layout="horizontal">
          <Form.Item
            label={ this.props.t("Tenancies.Tenancy") }
            style={{ margin: 0, paddingBottom: 14 }}
            {...formItemLayout}
          >
            { DateUtils.formatDate(tenancy.start_date) } - { DateUtils.formatDate(tenancy.end_date) }
          </Form.Item>
          <Form.Item
            label={ this.props.t("Tenancies.TenantName") }
            {...formItemLayout}
            style={{ margin: 0, paddingBottom: 14 }}
           name="official_tenant_name" rules={[{ required: true, message: `${ this.props.t("Tenancies.messages.Form.PleaseInputRegisteredTenantName") }` }]} initialValue={tenancy.official_tenant_name}>
            <Input placeholder={ this.props.t("Tenancies.TenantName") } />
          </Form.Item>
          <Form.Item
            label={ this.props.t("Tenancies.TenantEmail") }
            {...formItemLayout}
            style={{ margin: 0, paddingBottom: 14 }}
           name="official_tenant_email" rules={[{ required: false, message: "Please input registered tenant email" }]} initialValue={tenancy.official_tenant_email}>
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item
            label={ this.props.t("Tenancies.TenantPhone") }
            {...formItemLayout}
            style={{ margin: 0, paddingBottom: 14 }}
           name="official_tenant_phone_number" rules={[{ required: false, message: "Please input registered tenant phone number" }]} initialValue={tenancy.official_tenant_phone_number}>
            <Input placeholder="Phone Number" />
          </Form.Item>
          <Form.Item
            label={ `${this.props.t("Tenancies.TenantCorrespondenceAddress") } (${this.props.t("Tenancies.IfDifferentToPropertyAddress")})` }
            {...formItemLayout}
           name="correspondence_address" rules={[{ required: false, message: "Please input registered tenant correspondence address" }]} initialValue={tenancy.correspondence_address}>
            <Input.TextArea
                rows={ 3 }
              />
          </Form.Item>
          <Form.Item
            label="Management Fee"
            {...formItemLayout}
           name="include_mgmt_fee" rules={[{ required: true, message: 'Please select management fee' }]} initialValue={(tenancy.include_mgmt_fee || false).toString()}>
            <Radio.Group>
                <Radio value="true">Included</Radio>
                <Radio value="false">Excluded</Radio>
              </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Govt Rent"
            {...formItemLayout}
           name="include_govt_rent" rules={[{ required: true, message: 'Please select govt rent' }]} initialValue={(tenancy.include_govt_rent || false).toString()}>
            <Radio.Group>
                <Radio value="true">Included</Radio>
                <Radio value="false">Excluded</Radio>
              </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Govt Rates"
            {...formItemLayout}
           name="include_govt_rates" rules={[{ required: true, message: 'Please select govt rates' }]} initialValue={(tenancy.include_govt_rates || false).toString()}>
            <Radio.Group>
                <Radio value="true">Included</Radio>
                <Radio value="false">Excluded</Radio>
              </Radio.Group>
          </Form.Item>
          <Form.Item
            hasFeedback
            label={ this.props.t("shared.Notes") }
            {...formItemLayout}
            style={{ margin: 0, paddingBottom: 14 }}
           name="notes" initialValue={tenancy.notes}>
            <Input.TextArea rows={ 5 } />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {};
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  };
}

const ConnectedUpdateForm = connect(mapStateToProps, mapDispatchToProps)(UpdateForm);

const WrappedUpdateForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <ConnectedUpdateForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUpdateForm);
